export default __webpack_public_path__ + "static/media/regulatory--dual-speed-limits--g1.6752afbb.png";